let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fdTu1")).then(() => parcelRequire('8cDIv'));